import { render, staticRenderFns } from "./ClinicShowDoctorComissions.vue?vue&type=template&id=7f09b0ca"
import script from "./ClinicShowDoctorComissions.vue?vue&type=script&lang=js"
export * from "./ClinicShowDoctorComissions.vue?vue&type=script&lang=js"
import style0 from "./ClinicShowDoctorComissions.vue?vue&type=style&index=0&id=7f09b0ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports